import * as actions from '../actions/actions'
import update from "immutability-helper";
const initialState = {
    reportResponse:'',
    currentTab:'',
    corporates:[],
    campaigns:[],
    hasGeneralReportModal: false,
    hasGeneralReportDetailModal: false,
    files:[],
    plickStatusType:[],
    reportFilter:{
        bankId:'',
        bankIdsSelected:[],
        corporateId:'',
        corporateIdsSelected:[],
        campaignId:'',
        campaignIdsSelected:[],
        fileId:'',
        fileIdSelected:[],
        dateStart:'',
        dateEnd:'',
        whatsapp:true,
        sms:true,
        email:true,
        ordinary:true,
        futureDate:true,
        status:'',
        statusSelected:[],
        chartImage:'',
    },
    corporateFileStats:{
        bankId:'',
        corporateId:''
    },
    corporateFileStatsResponse:[],
    bankStats:{
        bankId:''
    },
    bankStatsResponse:[],
    corporateStats:{
        corporateId:''
    },
    corporateStatsResponse:[],
    plickStatsBankId:'',
    plickStatsResponse:[],
    error: '',
}

export default function report(state = initialState, action) {
    switch (action.type) {
        case actions.TOGGLE_GENERAL_REPORT_MODAL:
            return toggleGeneralReportModal(state,action);
        case actions.TOGGLE_GENERAL_REPORT_DETAIL_MODAL:
            return toggleGeneralReportDetailModal(state,action);
        case actions.FETCH_REPORT_GENERAL_SUCCESS:
            return updateReportResponse(state,action);
        case actions.FETCH_REPORT_PLICKSTATUS_TYPE_SUCCESS:
            return updatePlickStatusType(state,action);
        case actions.FETCH_REPORT_PLICK_STATS_SUCCESS:
            return updatePlickStatsResponse(state,action);
        case actions.FETCH_REPORT_CORPORATE_SUCCESS:
            return updateCorporates(state,action);
        case actions.FETCH_REPORT_CORPORATE_FAILURE:
            return getGeneralReportError(state,action);
        case actions.FETCH_REPORT_CAMPAIGN_SUCCESS:
            return updateCampaigns(state,action);
        case actions.FETCH_REPORT_CAMPAIGN_FAILURE:
            return getGeneralReportError(state,action);
        case actions.FETCH_REPORT_FILES_SUCCESS:
            return updateFiles(state,action);
        case actions.FETCH_REPORT_FILES_FAILURE:
            return getGeneralReportError(state,action);
        case actions.REPORT_GENERAL_BANK_FIELD_CHANGE:
            return updateReportGeneralBankField(state,action);
        case actions.REPORT_GENERAL_CORPORATE_FIELD_CHANGE:
            return updateReportGeneralCorporateField(state,action);
        case actions.REPORT_GENERAL_CAMPAIGN_FIELD_CHANGE:
            return updateReportGeneralCampaignField(state,action);
        case actions.REPORT_GENERAL_FILE_FIELD_CHANGE:
            return updateReportGeneralFileField(state,action);
        case actions.REPORT_GENERAL_DATESTART_FIELD_CHANGE:
            return updateReportGeneralDateStartField(state,action);
        case actions.REPORT_GENERAL_DATEEND_FIELD_CHANGE:
            return updateReportGeneralDateEndField(state,action);
        case actions.REPORT_GENERAL_WHATSAPP_FIELD_CHANGE:
            return updateReportGeneralWhatsappField(state,action);
        case actions.REPORT_GENERAL_SMS_FIELD_CHANGE:
            return updateReportGeneralSmsField(state,action);
        case actions.REPORT_GENERAL_EMAIL_FIELD_CHANGE:
            return updateReportGeneralEmailField(state,action);
        case actions.REPORT_GENERAL_ORDINARY_FIELD_CHANGE:
            return updateReportGeneralOrdinaryField(state,action);
        case actions.REPORT_GENERAL_FUTUREDATE_FIELD_CHANGE:
            return updateReportGeneralFutureDateField(state,action);
        case actions.REPORT_GENERAL_STATUS_FIELD_CHANGE:
            return updateReportGeneralStatusField(state,action);
        case actions.REPORT_CORPORATE_FILE_STATS_BANK_FIELD_CHANGE:
            return updateFileStatsBankField(state,action);
        case actions.REPORT_CORPORATE_FILE_STATS_CORPORATE_FIELD_CHANGE:
            return updateFileStatsCorporateField(state,action);
        case actions.FETCH_REPORT_CORPORATE_FILE_STATS_SUCCESS:
            return updateFileStatsResponse(state,action);
        case actions.FETCH_REPORT_GENERAL_FAILURE:
            return getGeneralReportError(state,action);
        case actions.CREATE_REPORT_CLEAN:
            return createReportClean(state, action)
        case actions.PLICK_STATS_BANK_FIELD_CHANGE:
            return updatePlickStatsBankField(state,action);
        case actions.REPORT_GENERAL_CHART_IMAGE:
            return updateChartImage(state,action);
        default:
            return state
    }
}

const toggleGeneralReportModal = (state, action) => {
    return update(
      state,
      {
          hasGeneralReportModal: {$set: !state.hasGeneralReportModal}
      }
    )
}

const toggleGeneralReportDetailModal = (state, action) => {
    return update(
      state,
      {
          hasGeneralReportDetailModal: {$set: !state.hasGeneralReportDetailModal}
      }
    )
}

const createReportClean = (state, action) => {
    return initialState;
}

const updatePlickStatusType = (state,action)=>{
    return update(
        state,
        {plickStatusType: {$set: action.value}}
    )
}
const updatePlickStatsResponse = (state,action)=>{
    return update(
        state,
        {plickStatsResponse: {$set: action.value}}
    )
}

const updateCorporates = (state,action)=>{
    return update(
        state,
        {corporates: {$set: action.value}}
    )
}

const updateCampaigns = (state,action)=>{
    return update(
        state,
        {campaigns: {$set: action.value}}
    )
}

const updateFiles = (state,action)=>{
    return update(
        state,
        {files: {$set: action.value}}
    )
}


const updateReportResponse = (state,action) => {
    return update(
        state,
        {reportResponse: {$set: action.value}}
    )
}

const updateFileStatsResponse = (state,action) => {
    return update(
        state,
        {corporateFileStatsResponse: {$set: action.value}}
    )
}


const updateReportGeneralBankField = (state, action) => {
    let bankIdSelectedList=[]
    action.value.map(bank=>{
        bankIdSelectedList.push(bank.bankId)
    })
    return update(
        state,
        {reportFilter: {bankId: {$set: action.value},bankIdsSelected:{$set:bankIdSelectedList}}}
    )
}

const updateReportGeneralCorporateField = (state, action) => {
    let corporateSelectedList=[]
    action.value.map(corporate=>{
        corporateSelectedList.push(corporate.corporateSenderId)
    })
    return update(
        state,
        {reportFilter: {corporateId: {$set: action.value},corporateIdsSelected:{$set: corporateSelectedList}}}
    )
}

const updateReportGeneralCampaignField = (state, action) => {
    let campaignSelectedList=[]
    action.value.map(campaign=>{
        campaignSelectedList.push(campaign.idLogo)
    })
    return update(
        state,
        {reportFilter: {campaignId: {$set: action.value},campaignIdsSelected: {$set: campaignSelectedList}}}
    )
}

const updateReportGeneralFileField = (state, action) => {
    let fileSelectedList=[]
    action.value.map(file=>{
        fileSelectedList.push(file.id)
    })
    return update(
        state,
        {reportFilter: {fileId: {$set: action.value},fileIdSelected: {$set: fileSelectedList}}}
    )
}

const updateReportGeneralDateStartField = (state, action) => {
    return update(
        state,
        {reportFilter: {dateStart: {$set: action.value}}}
    )
}

const updateReportGeneralDateEndField = (state, action) => {
    return update(
        state,
        {reportFilter: {dateEnd: {$set: action.value}}}
    )
}

const updateReportGeneralWhatsappField = (state, action) => {
    return update(
        state,
        {reportFilter: {whatsapp: {$set: action.value}}}
    )
}

const updateReportGeneralSmsField = (state, action) => {
    return update(
        state,
        {reportFilter: {sms: {$set: action.value}}}
    )
}

const updateReportGeneralEmailField = (state, action) => {
    return update(
        state,
        {reportFilter: {email: {$set: action.value}}}
    )
}

const updateReportGeneralOrdinaryField = (state, action) => {
    return update(
        state,
        {reportFilter: {ordinary: {$set: action.value}}}
    )
}
const updateReportGeneralFutureDateField = (state, action) => {
    return update(
        state,
        {reportFilter: {futureDate: {$set: action.value}}}
    )
}

const updateReportGeneralStatusField = (state, action) => {
    let plickStatus=[]
    action.value.map(status=>{
        plickStatus.push(status.key)
    })
    return update(
        state,
        {reportFilter: {status: {$set: action.value},statusSelected: {$set: plickStatus}}}
    )
}

const updateChartImage = (state, action) => {
    return update(
        state,
        {reportFilter:{chartImage:{$set: action.value}}}
    )
}

const updatePlickStatsBankField = (state, action) => {
    return update(
        state,
        {plickStatsBankId:{$set: action.value}}
    )
}
const updateFileStatsBankField = (state, action) => {
    return update(
        state,
        {corporateFileStats: {bankId: {$set: action.value}}}
    )
}

const updateFileStatsCorporateField = (state, action) => {
    return update(
        state,
        {corporateFileStats: {corporateId: {$set: action.value}}}
    )
}

const getGeneralReportError = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}